<!-- Hosted "Pay invoice by ACH" page. Layout follows design/prototype/pay-ach.html. -->
<div class="hosted-page">
  <div class="hosted">
    <!-- Loading: just the page background and a spinner; the card appears once the invoice is in. -->
    <div class="hosted-loading" *ngIf="loadFlag" role="status" aria-live="polite">
      <img class="hosted-spinner" src="../../../assets/images/loading.svg" alt="" aria-hidden="true">
      <span class="sr-only">Loading invoice</span>
    </div>

    <div class="hosted-card" *ngIf="!loadFlag">
      <ng-container *ngIf="!loadFlag">
        <div class="hosted-card__head">
          <h1 class="hosted-card__title">Invoice from {{ReceievedInvoice.account_name}}</h1>
          <div class="bill-grid">
            <div>
              <p>Billed to {{ReceievedInvoice.customer_name}}</p>
              <p>Invoice #{{ReceievedInvoice.invoice_number}}</p>
            </div>
            <div class="r" *ngIf="ReceievedInvoice.amount_due">
              <p class="due">{{ (ReceievedInvoice.amount_due / 100 | currency:'USD':'symbol':'1.2-2') + ' USD' }} due on</p>
              <p>{{ ReceievedInvoice.payment_due_date ? (ReceievedInvoice.payment_due_date | dateFormat: 'MMM dd, yy') : '--' }}</p>
            </div>
          </div>
        </div>

        <div class="hosted-card__body">
          <!-- Paid -->
          <div class="paid-state" *ngIf="ReceievedInvoice.paid === 1">
            <div class="check_mark">
              <div class="sa-icon sa-success animate">
                <span class="sa-line sa-tip animateSuccessTip"></span>
                <span class="sa-line sa-long animateSuccessLong"></span>
                <div class="sa-placeholder"></div>
                <div class="sa-fix"></div>
              </div>
            </div>
            <span class="paid">Paid</span>
          </div>

          <!-- Pay by ACH -->
          <ng-container *ngIf="ReceievedInvoice.paid !== 1">
            <h2 class="pay-h">Pay By ACH</h2>

            <div class="pay-alerts">
              <payarc-inline-alert *ngIf="failureMessage" variant="bad">{{failureMessage}}</payarc-inline-alert>
              <ng-container *ngIf="topErrorMessage">
                <ng-container *ngFor="let obj of keys1">
                  <payarc-inline-alert *ngFor="let value of obj" variant="bad">{{value}}</payarc-inline-alert>
                </ng-container>
              </ng-container>
              <payarc-inline-alert *ngIf="!topErrorMessage && errorMsg" variant="bad">{{errorMsg}}</payarc-inline-alert>
            </div>

            <form [formGroup]="manualInvoiceForm" (ngSubmit)="manualInvoiceForm.invalid ? print(manualInvoiceForm) : payInvoice()" #manualInvoiceFormF="ngForm" novalidate>
              <div class="fld-2">
                <div class="fld">
                  <label for="account_number">Account number</label>
                  <input class="pa-input" id="account_number" name="account_number" type="text" inputmode="numeric"
                         autocomplete="off" credit-card maxlength="17"
                         [class.invalid]="manualInvoiceForm.controls['accountNumber'].invalid && manualInvoiceFormF.submitted"
                         (keypress)="numericOnly($event)"
                         [(ngModel)]="bank_account.bank_account_number" formControlName="accountNumber">
                  <span class="fld__err" *ngIf="manualInvoiceFormF.submitted && manualInvoiceForm.controls['accountNumber'].errors?.required">
                    Account number is required.
                  </span>
                  <span class="fld__err" *ngIf="manualInvoiceFormF.submitted && !manualInvoiceForm.controls['accountNumber'].errors?.required && manualInvoiceForm.controls['accountNumber'].invalid">
                    Account number is invalid.
                  </span>
                </div>
                <div class="fld">
                  <label for="routing_number">Routing number</label>
                  <input class="pa-input" id="routing_number" name="routing_number" type="text" inputmode="numeric"
                         autocomplete="off" credit-card maxlength="9"
                         [class.invalid]="manualInvoiceForm.controls['routingNumber'].invalid && manualInvoiceFormF.submitted"
                         (keypress)="numericOnly($event)"
                         [(ngModel)]="bank_account.routing_number" formControlName="routingNumber">
                  <span class="fld__err" *ngIf="manualInvoiceFormF.submitted && manualInvoiceForm.controls['routingNumber'].errors?.required">
                    Routing number is required.
                  </span>
                  <span class="fld__err" *ngIf="manualInvoiceFormF.submitted && !manualInvoiceForm.controls['routingNumber'].errors?.required && manualInvoiceForm.controls['routingNumber'].invalid">
                    Routing number is invalid.
                  </span>
                </div>
              </div>

              <div class="fld-2">
                <div class="fld">
                  <label for="first_name">First name</label>
                  <input class="pa-input" id="first_name" name="accountholderFirst" type="text" autocomplete="given-name"
                         [class.invalid]="manualInvoiceForm.controls['accountholderFirst'].invalid && manualInvoiceFormF.submitted"
                         [(ngModel)]="bank_account.account_holder_first_name" formControlName="accountholderFirst">
                  <span class="fld__err" *ngIf="manualInvoiceFormF.submitted && manualInvoiceForm.controls['accountholderFirst'].errors?.required">
                    First name is required.
                  </span>
                </div>
                <div class="fld">
                  <label for="last_name">Last name</label>
                  <input class="pa-input" id="last_name" name="accountholderLast" type="text" autocomplete="family-name"
                         [class.invalid]="manualInvoiceForm.controls['accountholderLast'].invalid && manualInvoiceFormF.submitted"
                         [(ngModel)]="bank_account.account_holder_last_name" formControlName="accountholderLast">
                  <span class="fld__err" *ngIf="manualInvoiceFormF.submitted && manualInvoiceForm.controls['accountholderLast'].errors?.required">
                    Last name is required.
                  </span>
                </div>
              </div>

              <div class="fld">
                <label for="account_type">Account type</label>
                <select class="pa-input" id="account_type" name="account_type"
                        [class.invalid]="manualInvoiceForm.controls['account_type'].invalid && manualInvoiceFormF.submitted"
                        [(ngModel)]="bank_account.account_type" formControlName="account_type">
                  <option value="" disabled hidden></option>
                  <option *ngFor="let type of category_test" [ngValue]="type.value">{{type.value}}</option>
                </select>
                <span class="fld__err" *ngIf="manualInvoiceFormF.submitted && manualInvoiceForm.controls['account_type'].errors?.required">
                  Account type is required.
                </span>
              </div>

              <div class="fld">
                <label for="street">Address</label>
                <input class="pa-input" id="street" name="street" type="text" autocomplete="street-address"
                       [class.invalid]="manualInvoiceForm.controls['street'].invalid && manualInvoiceFormF.submitted"
                       [(ngModel)]="achcharge.address_line1" formControlName="street"
                       appPlacesAutocomplete [options]="options" (onAddressChange)="handleAddressChange($event)">
                <span class="fld__err" *ngIf="manualInvoiceFormF.submitted && manualInvoiceForm.controls['street'].errors?.maxlength">
                  Address is too long.
                </span>
              </div>

              <div class="fld-2">
                <div class="fld">
                  <label for="city">City</label>
                  <input class="pa-input" id="city" name="city" type="text" maxlength="200" autocomplete="address-level2"
                         [class.invalid]="manualInvoiceForm.controls['city'].invalid && manualInvoiceFormF.submitted"
                         [(ngModel)]="achcharge.city" formControlName="city">
                </div>
                <div class="fld">
                  <label for="state">State / Province</label>
                  <select class="pa-input" id="state" name="state" [(ngModel)]="achcharge.state" formControlName="state">
                    <option value="" disabled hidden></option>
                    <option *ngFor="let state of states" [value]="state.name">{{state.name}}</option>
                  </select>
                </div>
              </div>

              <div class="fld-2">
                <div class="fld">
                  <label for="zip">Zip code</label>
                  <input class="pa-input" id="zip" name="zip" type="text" maxlength="10" inputmode="numeric" autocomplete="postal-code"
                         [class.invalid]="manualInvoiceForm.controls['zip'].invalid && manualInvoiceFormF.submitted"
                         (keypress)="numericOnly($event)" [(ngModel)]="achcharge.zip" formControlName="zip">
                </div>
                <div class="fld">
                  <label for="country">Country</label>
                  <select class="pa-input" id="country" name="country" [ngModel]="achcharge.country" formControlName="country">
                    <option value="" disabled hidden></option>
                    <option *ngFor="let country of countries" [value]="country.key">{{country.name}}</option>
                  </select>
                </div>
              </div>

              <button type="submit" class="pa-btn pa-btn--primary pay-submit" [disabled]="load">
                Pay Invoice <i *ngIf="load" class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
              </button>
            </form>
          </ng-container>

          <!-- Line items -->
          <div class="lineitems">
            <div class="li-period">
              {{ ReceievedInvoice.period_start ? (ReceievedInvoice.period_start | dateFormat: 'MMM dd, yy') : '--' }}
              –
              {{ ReceievedInvoice.period_end ? (ReceievedInvoice.period_end | dateFormat: 'MMM dd, yy') : '--' }}
            </div>
            <table class="li-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th class="c">Qty</th>
                  <th>Unit price</th>
                  <th class="r">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ReceievedInvoice.plan_name}}</td>
                  <td class="c">{{ReceievedInvoice.quantity > 0 ? ReceievedInvoice.quantity : 1}}</td>
                  <td>{{ ReceievedInvoice.plan_amount != null ? ((ReceievedInvoice.plan_amount / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</td>
                  <td class="r">{{ ReceievedInvoice.plan_amount != null ? ((ReceievedInvoice.plan_amount / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</td>
                </tr>
              </tbody>
            </table>

            <div class="li-totals">
              <div class="row-t">
                <span>Sub Total</span>
                <span>{{ ReceievedInvoice.subtotal != null ? ((ReceievedInvoice.subtotal / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</span>
              </div>
              <div class="row-t" *ngIf="ReceievedInvoice.tax_amount">
                <span>Tax</span>
                <span>{{ ((ReceievedInvoice.tax_amount / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' }}</span>
              </div>
              <div class="row-t">
                <span>Total</span>
                <span>{{ ReceievedInvoice.total != null ? ((ReceievedInvoice.total / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</span>
              </div>
              <div class="row-t">
                <span>Amount Paid</span>
                <span>{{ ReceievedInvoice.amount_paid != null ? ((ReceievedInvoice.amount_paid / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</span>
              </div>
              <div class="row-t" *ngIf="ReceievedInvoice.discount_amount">
                <span>Discount Amount</span>
                <span>{{ ((ReceievedInvoice.discount_amount / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' }}</span>
              </div>
              <div class="row-t grand" *ngIf="ReceievedInvoice.amount_due">
                <span>Amount Due</span>
                <span>{{ ((ReceievedInvoice.amount_due / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' }}</span>
              </div>
            </div>

            <div class="dl-row">
              <button type="button" class="pa-btn pa-btn--ghost dl-link" (click)="dlInvoice()">Download Invoice</button>
              <button type="button" class="pa-btn pa-btn--ghost dl-link" *ngIf="ReceievedInvoice.paid === 1" (click)="dlreceipt()">Download Receipt</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
